<template>
  <div class="appointment">
    <common-head title="预约信息" go="/home" />
    <div class="main">
      <!-- 受种者 -->
      <div class="person">
        <div class="header">
          <b>选择受种者</b>
        </div>
        <div class="my-card">
          <div
            v-for="(item, index) in members"
            :key="index"
            :class="{current: index == n}"
            @click="changeMember(index)"
          >
            <span>{{ item.name }}</span>
            <div class="info">
              {{ item.sex }} | {{ item.ageDesc }}
            </div>
          </div>
        </div>
      </div>
      <!-- 门诊 -->
      <div class="office">
        <div class="header">
          <b>接种门诊</b>
          <van-tag 
            plain 
            type="primary" 
            size="large" 
            v-if="isShow || !office"
            @click="enterOffice"
          >
            切换门诊
          </van-tag>
        </div>
        <div class="my-card my-tags" v-if="office">
          <div class="row-top">{{ office.name }}</div>
          <div class="row-mid">
            <van-tag
              plain
              type="primary"
              v-for="(item, index) in office.types"
              :key="index"
            >
              {{ item }}
            </van-tag>
            <van-tag plain type="primary" v-if="office.isTwentyFourHours">24H</van-tag>
          </div>
          <div class="row-btm">
            <div class="left van-ellipsis">
              <img src="@/assets/imgs/map.png">
              <span>{{ office.registerAddress }}</span>
            </div>
            <div class="right">{{ office.distance }}km</div>
          </div>
        </div>
      </div>
      <!-- 疫苗 -->
      <div class="vacc">
        <div class="header">
          <b>选择预约疫苗</b>
          <van-tag 
            plain 
            type="primary" 
            size="large"
            v-if="vaccList.length"
            @click="enterVacc"
          >
            切换疫苗
          </van-tag>
        </div>
        <div class="my-card plus" v-if="!vaccList.length">
          <van-icon name="plus" @click="enterVacc" />
        </div>
        <div class="my-card" v-else>
          <van-radio-group v-model="value" icon-size="14px">
            <div 
              class="radio-box" 
              v-for="(item, index) in vaccList" 
              :key="index"
            >
              <van-radio :name="index" class="radio"></van-radio>
              <div class="row1">
                <b>{{ item.vaccineName }}</b>
                <span class="price" v-if="item.notImmunizationPlanning">{{ item.sellPriceDes }}</span>
                <van-tag plain type="success" v-else>{{ item.sellPriceDes }}</van-tag>
              </div>
              <div class="row2">
                {{ item.manufacturer }}
              </div>
            </div>
          </van-radio-group>
        </div>
      </div>
    </div>
    <div class="my-button">
      <van-button type="info" round @click="enterDeclaration">选择号源</van-button>
    </div>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { fetchReccentMember } from 'api/user'
import { fetchAdultOffice, fetchChildOffice } from 'api/office'
import getLocation from 'utils/getLocation'
import { convertToArrTxt } from 'utils/handlePovType'
import { mapState } from 'vuex'

export default {
  name: 'appointment',
  components: {
    CommonHead
  },
  computed: {
    ...mapState(['family', 'user', 'vacc', 'key', 'openid']),
    isShow() {
      return this.members[this.n]?.age >= 18 ? true : false // 区分成人和儿童
    }
  },
  data() {
    return {
      location: {
        lon: '',
        lat: ''
      },
      n: -1,
      members: [],
      office: null,
      vaccList: [],
      value: 0,
    }
  },
  created() {
    this.handleMembers()
    this.getRecentMember()
  },
  activated() {
    const { officeCopy, vacc } = this.$store.state
    // 回写门诊
    if (officeCopy) {
      this.office = officeCopy
      this.vaccList = []
    }
    // 回写疫苗
    if (vacc) {
      this.vaccList = [vacc]
    }
  },
  methods: {
    // 不同入口进来时的成员展示
    handleMembers() {
      switch (this.key) {
        case 'children':
          this.members = this.family.filter(v => v.age < 18)
          break;
        case 'adult':
          this.members = this.family.filter(v => v.age >= 18)
          break;
        default:
          this.members = this.family
      }
    },
    // 最近一次接种的人
    getRecentMember() {
      fetchReccentMember().then(res => {
        // 处理默认高亮
        const { data } = res
        if (!data) {
          this.n = 0
        } else {
          const index = this.members.findIndex(v => v.profileCode == data.profileCode)
          if (index == -1) {
            this.n = 0
          } else {
            this.n = index
          }
        }
        // 获取默认门诊
        if (process.env.NODE_ENV == 'production') {
          getLocation().then(res => {
            this.location.lon = res.longitude
            this.location.lat = res.latitude
            this.getOffice()
          })
        } else {
          this.location.lon = 117.1241210
          this.location.lat = 31.83
          this.getOffice()
        }
      })
    },
    getOffice() {
      let params = {
        ...this.location,
        profileCode: this.members[this.n].profileCode
      }
      if (this.isShow) {
        switch (this.key) {
          case 'rabies':
            params.vaccineSupIdList = '28'
            params.povType = '4'
            break;
          case 'xg':
            params.vaccineSupIdList = '56'
            params.povType = '5'
            break;
          case 'flu':
            params.vaccineSupIdList = '21'
            params.povType = '6'
            break;
          default:
            params.vaccineSupIdList = '21,25,22,02,56'
            params.povType = '3'
            break;
        }
        fetchAdultOffice(params, {hideLoading: true}).then(res => {
          this.handleOfficeData(res)
        })
      } else {
        fetchChildOffice(params, {hideLoading: true}).then(res => {
          this.handleOfficeData(res)
        })
      }
    },
    handleOfficeData(res) {
      let { data } = res
      if (JSON.stringify(data) == '{}') {
        this.office = null
      } else {
        data.types = convertToArrTxt(data.povType)
        this.office = data
      }
    },
    // 选择受种人
    changeMember(index) {
      if (index == this.n) return
      this.n = index
      this.vaccList = []
      this.getOffice()
    },
    enterOffice() {
      this.$router.push('office')
    },
    // 进入添加疫苗
    enterVacc() {
      if (!this.office) {
        return this.$toast('请选择接种门诊')
      }
      const query = {
        povCode: this.office.povCode,
        profileCode: this.members[this.n].profileCode
      }
      if (this.key == 'adult' || this.key == 'children') {
        this.$router.push({
          path: '/add-vacc',
          query
        })
      } else {
        this.$router.push({
          path: '/vacc',
          query
        })
      }
    },
    enterDeclaration() {
      const member = this.members[this.n]
      if ((member.relation == '本人' || member.relation == '1') && (member.verify != '1' || !member.isGranted)) {
        return this.$toast('请先前往就近门诊认证档案后预约')
      }
      if (!this.office) {
        return this.$toast('请选择接种门诊')
      }
      if (!this.vaccList.length) {
        return this.$toast('请选择预约疫苗')
      }
      // 预约下单接口参数预处理
      let reservationType
      if (this.key == 'rabies') {
        reservationType = 3
      } else {
        if (this.isShow) {
          reservationType = 2
        } else {
          reservationType = 1
        }
      }
      const params = {
        addAppReservationDetailREQ: [
          {
            batchNo: this.vacc.batchNo,
            manufacturer: this.vacc.manufacturer,
            manufacturerCode: this.vacc.manufacturerCode,
            payStatus: '1',
            price: this.vacc.sellPrice,
            profileCode: this.members[this.n].profileCode,
            profileId: this.members[this.n].profileId,
            status: '1',
            traceCode: this.vacc.traceCode,
            vaccinateNo: this.vacc.vaccineNo,
            vaccineCode: this.vacc.vaccineCode,
            vaccineName: this.vacc.vaccineName
          }
        ],
        channel: '皖事通',
        povCode: this.office.povCode,
        povName: this.office.name,
        profileCode: this.members[this.n].profileCode,
        profileId: this.members[this.n].profileId,
        profileName: this.members[this.n].name,
        reservationType,
        status: '1',
        userId: this.openid,
        // 回显用
        povType: this.office.povType,
        address: this.office.registerAddress,
        time: this.office.workTime + ' ' + this.office.vaccinateTime
      }
      this.$store.commit('setParams', params)

      this.$router.push({
        path: '/declaration',
        query: {
          vaccineCode: this.vacc.vaccineCode,
          povCode: params.povCode
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.appointment {
  padding-bottom: 81px;
  .main {
    padding: 13px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 11px;
      b {
        opacity: .85;
      }
    }
    .person {
      margin-bottom: 13px;
      .my-card {
        padding-bottom: 0 !important;
        display: flex;
        flex-wrap: wrap;
        >div {
          width: 84px;
          height: 56px;
          border: 1px solid #ddd;
          border-radius: 3px;
          box-sizing: border-box;
          padding: 0 11px;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          margin-right: 11px;
          margin-bottom: 11px;
          span {
            font-weight: bold;
            opacity: .85;
          }
          .info {
            font-size: 12px;
            color: var(--grey);
            opacity: .85;
          }
        }
        .current {
          border-color: var(--blue) !important;
        }
      }
    }
    .my-tags {
      margin: 13px 0;
    }
    .vacc {
      .plus {
        box-sizing: border-box;
        height: 67px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--grey);
        opacity: .85;
      }
      .radio-box {
        padding-left: 25px;
        padding-bottom: 11px;
        border-bottom: 1px solid #eee;
        margin-bottom: 11px;
        position: relative;
        &:last-child {
          padding-bottom: 0;
          border-bottom: 0;
          margin-bottom: 0;
        }
        .radio {
          position: absolute;
          left: 0;
          top: 3px;
        }
        .row1 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 11px;
          b {
            flex: 3;
            opacity: .9;
          }
          .price {
            flex: 1;
            text-align: right;
            color: var(--orange);
            font-weight: bold;
            opacity: .9;
          }
        }
        .row2 {
          font-size: 12px;
          color: var(--grey);
          font-weight: 400;
          opacity: .9;
        }
      }
    }
  }
}
</style>